export const AddNewItemOperationConst = {
    create: 1,
    update: 2,
    delete: 3
}